import React, { useMemo } from 'react'
import { makeStyles } from '@material-ui/core'
import HotSwapShowDeviceLabel from './how-swap-show-device-label'
import { NavLink } from 'react-router-dom'
import { ExportFileIcon } from '../../root/components/common/export-icon'

const HotSwapLocations = ({
    selectedHotSwapLocations,
    locale,
    showChangeLocation,
    isAdmin,
    exportHotswap
}) => {
    const classes = useStyles()
    const totalSelectedDevices = useMemo(() => {
        return selectedHotSwapLocations?.reduce(
            (sum, selectedLocation) =>
                sum + Number(selectedLocation.device_count),
            0
        )
    }, [selectedHotSwapLocations])
    return (
        <>
            {selectedHotSwapLocations?.map(selectedLocation => (
                <div
                    key={selectedLocation.name}
                    className={classes.spaceBetween}>
                    <div className={classes.locationDetails}>
                        <span className={classes.titleText}>
                            {selectedLocation.name}
                        </span>
                        <span className={classes.regularText}>
                            {selectedLocation.customer_name}
                        </span>
                    </div>
                    <div className={classes.quantityDetails}>
                        {!!exportHotswap && (
                            <div onClick={() => exportHotswap('xlsx')}>
                                <ExportFileIcon
                                    fileType="excel"
                                    size="medium"
                                    locale={locale}
                                />
                            </div>
                        )}

                        <span className={classes.quantityLabel}>
                            <HotSwapShowDeviceLabel
                                deviceQuantity={selectedLocation.device_count}
                            />
                        </span>
                    </div>
                </div>
            ))}
            {!isAdmin && showChangeLocation && (
                <div className={classes.summary}>
                    <span className={classes.quantityLabel}>
                        <HotSwapShowDeviceLabel
                            deviceQuantity={totalSelectedDevices}
                        />
                    </span>
                    <NavLink
                        className={classes.highlightItemBold}
                        to={`/hot-swap`}>
                        {locale.hotSwap.summary.changeLocation}
                    </NavLink>
                </div>
            )}
            {!isAdmin && !showChangeLocation && (
                <div
                    className={`${classes.summary} ${classes.directionColumn}`}>
                    <div
                        className={`${classes.quantityLabel} ${classes.alignRight}`}>
                        <HotSwapShowDeviceLabel
                            deviceQuantity={totalSelectedDevices}
                        />
                    </div>
                </div>
            )}
        </>
    )
}

export default HotSwapLocations

const useStyles = makeStyles(theme => ({
    spaceBetween: {
        display: 'flex',
        justifyContent: 'space-between'
    },
    locationDetails: {
        display: 'flex',
        flexDirection: 'column'
    },
    quantityDetails: {
        display: 'flex',
        alignItems: 'center',
        gap: 8
    },
    quantityLabel: {
        borderRadius: theme.borderRadius,
        fontWeight: 500,
        fontSize: '13px',
        padding: '3px 6px',
        color: theme.gray,
        backgroundColor: theme.grayLight
    },
    titleText: {
        fontWeight: 500,
        fontSize: '13px',
        color: theme.blueDark
    },
    regularText: {
        fontWeight: 300,
        fontSize: '13px',
        color: '#475467',
        lineHeight: '20px'
    },
    highlightItemBold: {
        color: theme.blueDark,
        fontWeight: 600,
        textDecoration: 'none',
        fontSize: '14px',
        lineHeight: '20px'
    },
    summary: {
        display: 'flex',
        justifyContent: 'space-between',
        borderTop: '1px solid #EAECF0',
        paddingTop: '1rem'
    },
    alignRight: {
        marginLeft: 'auto'
    }
}))
